/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "merchant_catalog": {
                "nested": {
                  "service": {
                    "nested": {
                      "CountCatalogObjectsRequest": {
                        "fields": {
                          "types": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional",
                            "options": {
                              "default": "ITEM"
                            }
                          },
                          "limit": {
                            "type": "int32",
                            "id": 2,
                            "rule": "optional",
                            "options": {
                              "default": 1
                            }
                          },
                          "presentAtLocations": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional",
                            "options": {
                              "default": ""
                            }
                          }
                        }
                      },
                      "CountCatalogObjectsResponse": {
                        "fields": {
                          "errors": {
                            "type": ".squareup.connect.v2.resources.Error",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "count": {
                            "type": "int32",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.CountCatalogObjectsRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.CountCatalogObjectsResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CountCatalogObjectsRequest @ squareup/connect/v2/catalog/interfaces/count-catalog-objects.proto at 18:1
 */
export const CountCatalogObjectsRequest = $root.lookupType('squareup.connect.v2.merchant_catalog.service.CountCatalogObjectsRequest');
fixType(CountCatalogObjectsRequest);
Builder.createAndAttachToType(CountCatalogObjectsRequest);
/**
 * SOURCE CountCatalogObjectsResponse @ squareup/connect/v2/catalog/interfaces/count-catalog-objects.proto at 51:1
 */
export const CountCatalogObjectsResponse = $root.lookupType('squareup.connect.v2.merchant_catalog.service.CountCatalogObjectsResponse');
fixType(CountCatalogObjectsResponse);
Builder.createAndAttachToType(CountCatalogObjectsResponse);